import React, { useState } from 'react';
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';
import { InputMoney } from '@4beefopag/4bee-fopag-core/dist/atoms';

function InputMoneyWithCheckbox({ label, onChangeCheckbox, isInputEnabled, moneyValue, onChangeMoneyValue }) {
  const [isInputLocalEnabled, setIsInputLocalEnabled] = useState(isInputEnabled);
  const [valueLocal, setValueLocal] = useState(moneyValue);
  const checkedValue = isInputEnabled !== undefined ? isInputEnabled : isInputLocalEnabled;
  return (
    <div>
      <Checkbox
        onChange={(e) => {
          if (onChangeCheckbox) onChangeCheckbox(e.target.checked);
          setIsInputLocalEnabled(e.target.checked);
        }}
        checked={checkedValue}
      >
        {label}
      </Checkbox>
      <InputMoney
        prefix="R$"
        disabled={!checkedValue}
        value={moneyValue !== undefined ? moneyValue : valueLocal}
        getValue={(value) => {
          if (onChangeMoneyValue) onChangeMoneyValue(value);
          setValueLocal(value);
        }}
      />
    </div>
  );
}

InputMoneyWithCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  onChangeCheckbox: PropTypes.func,
  onChangeMoneyValue: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  isInputEnabled: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  moneyValue: PropTypes.number,
};

InputMoneyWithCheckbox.defaultProps = {
  onChangeCheckbox: () => false,
  onChangeMoneyValue: () => false,
};

export default InputMoneyWithCheckbox;
